import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=b4a9958a&scoped=true&"
import script from "./DetailDrawer.vue?vue&type=script&lang=js&"
export * from "./DetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=b4a9958a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a9958a",
  null
  
)

export default component.exports